import { createSelector } from 'reselect';

const getState = (state) => state.coachScheduleSessions;

export const getLoading = createSelector(getState, (state) => !!state.loading);
export const getLoadingSession = createSelector(getState, (state) => !!state.loadingSession);
export const getUserSessions = createSelector(getState, (state) => state.data);
export const getCoachSessions = createSelector(getState, (state) => state.dataCoach);
export const getSession = createSelector(getState, (state) => state.session);
